
@switch (applicationStatus$ | async) {
  @case (ApplicationStatus.OFFLINE) {
    <div class="fullscreen" data-cy="offline-screen">
      <div>
        <mat-icon>cloud_off</mat-icon>
        <h1>Connexion perdue</h1>
        <p>
          Il semble que vous ayez perdu votre connexion internet. <br />
          Veuillez vérifier votre connexion.
        </p>
      </div>
    </div>
  }
  @case (ApplicationStatus.AUTH_REFRESH_ERROR) {
    <div class="fullscreen">
      <div>
        <mat-icon>logout</mat-icon>
        <h1>Vous êtes déconnecté </h1>
        <p>
          Il semble que votre session est expirée. <br />
          Veuillez vous reconnecter.
        </p>
        <button mat-raised-button (click)="reload()" type="button" color="primary">Se reconnecter</button>
      </div>
    </div>
  }
}
